import { getUserDisplayName } from "../../lib/userDisplayName";
import { SocialLinks } from "./SocialLinks";
import { COMMUNITY_PURPOSES, purposeFromTags } from "../../lib/communityParticipation";
import { Link } from "react-router-dom";
import { ArrowUpRight, Eye, Heart, MessageCircle } from "lucide-react";
import type { CommunityBoardFeedItem } from "../../lib/communityBoardFeed";
import {
  hasReadCommunityPost,
  markCommunityPostRead,
} from "../../lib/communityBoardState";

const dateFormatter = new Intl.DateTimeFormat("ko-KR", {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

export function CommunityFeedRow({
  item,
  notice = false,
}: {
  item: CommunityBoardFeedItem;
  notice?: boolean;
}) {
  const post = item.kind === "post" ? item.post : null;
  const site = item.kind === "vibe_site" ? item.site : null;
  const title = post?.title || site?.title || "";
  const category = post?.subcategory?.name || (site ? "바이브코딩" : "이야기");
  const author = post
    ? getUserDisplayName(post.author)
    : site?.author_display_name;
  const purpose = purposeFromTags(post?.tags);
  const purposeInfo = COMMUNITY_PURPOSES.find(p => p.id === purpose);
  const count = post?.num_comments ?? site?.comments_count ?? 0;
  const likes = post?.num_likes ?? site?.likes_count ?? 0;
  return (
    <li className={`fe-community-row${notice ? " is-notice" : ""}`}>
      <div
        className={`fe-community-row-link${post && hasReadCommunityPost(post.id) ? " is-read" : ""}`}
      >
        <Link
          className="fe-community-row-main"
          to={post ? `/community/board/${post.id}` : `/informate/vibe-sites/${site!.id}`}
          onClick={() => {
            if (post) markCommunityPostRead(post.id);
          }}
        >
          {!notice && purposeInfo && <span className={`fe-community-purpose-badge is-${purpose}`}>{purposeInfo.label}</span>}
          <span className={`fe-community-badge${site ? " is-violet" : ""}`}>
            {category}
          </span>
          <span className="fe-community-row-title">{title}</span>
          {site && <ArrowUpRight size={15} aria-hidden="true" />}
        </Link>
        <div className="fe-community-row-meta">
          <span className="fe-community-author-social">
            <span className="fe-community-author">{author}</span>
            {post && <SocialLinks links={post.author.social_links} authorName={author || undefined} />}
          </span>
          <time dateTime={item.created_at}>
            {dateFormatter.format(new Date(item.created_at))}
          </time>
          <span className="fe-community-metric">
            <Eye size={14} aria-hidden="true" />
            <span className="sr-only">조회 </span>
            {(post?.hits ?? site?.hits ?? 0).toLocaleString()}
          </span>
          <span className={`fe-community-metric${likes ? " has-likes" : ""}`}>
            <Heart size={14} aria-hidden="true" />
            <span className="sr-only">좋아요 </span>
            {likes.toLocaleString()}
          </span>
          <span
            className={`fe-community-metric${count ? " has-comments" : ""}`}
          >
            <MessageCircle size={14} aria-hidden="true" />
            <span className="sr-only">댓글 </span>
            {count}
          </span>
        </div>
      </div>
    </li>
  );
}
